import { bridgelessRestApiClient } from '@/api/clients'
import { buildPaginationParams } from '@/helpers'
import { PaginationParams, PaginationResponse } from '@/types'
import { Proposal, ProposalStatus, Vote } from '@/types/governance'

export interface ProposalsParams {
  proposal_status?: ProposalStatus
  voter?: string
  depositor?: string
  pagination?: PaginationParams
}

export interface ProposalsResponse {
  proposals: Proposal[]
  pagination: PaginationResponse
}

export async function fetchProposals(
  params?: ProposalsParams,
): Promise<ProposalsResponse> {
  const { data } = await bridgelessRestApiClient.get<ProposalsResponse>(
    '/cosmos/gov/v1/proposals',
    {
      params: {
        proposal_status: params?.proposal_status,
        voter: params?.voter,
        depositor: params?.depositor,
        ...buildPaginationParams(params?.pagination),
      },
    },
  )
  return data
}

export interface ProposalResponse {
  proposal: Proposal
}

export async function fetchProposal(
  proposalId: string,
): Promise<ProposalResponse> {
  const { data } = await bridgelessRestApiClient.get<ProposalResponse>(
    `/cosmos/gov/v1/proposals/${proposalId}`,
  )
  return data
}

export interface VotesResponse {
  votes: Vote[]
  pagination: PaginationResponse
}

export async function fetchProposalVotes(
  proposalId: string,
  pagination?: PaginationParams,
): Promise<VotesResponse> {
  const { data } = await bridgelessRestApiClient.get<VotesResponse>(
    `/cosmos/gov/v1/proposals/${proposalId}/votes`,
    {
      params: buildPaginationParams(pagination),
    },
  )
  return data
}

export interface VoteResponse {
  vote: Vote
}

export async function fetchVoterVote(
  proposalId: string,
  voter: string,
): Promise<VoteResponse> {
  const { data } = await bridgelessRestApiClient.get<VoteResponse>(
    `/cosmos/gov/v1/proposals/${proposalId}/votes/${voter}`,
  )
  return data
}
